function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { getColor } from '../../../../theme-tools';
import { asSingleStyleConfig } from '../../../../utils/theme';
import { getDefaults } from './inputDefaults';
var sizes = {
  md: props => {
    var {
      rightIcon,
      leftIcon,
      isLoading
    } = props;
    return {
      button: {
        minW: {
          base: '12rem',
          md: '15.5rem'
        },
        pl: leftIcon ? '2.875rem' : '1.25rem',
        pr: rightIcon || isLoading ? '2.875rem' : '1.25rem',
        height: '2.75rem'
      }
    };
  },
  sm: props => {
    var {
      rightIcon,
      leftIcon,
      isLoading
    } = props;
    return {
      button: {
        fontSize: 'sm',
        minW: {
          md: '6.5rem'
        },
        pl: leftIcon ? '2.25rem' : '1rem',
        pr: rightIcon || isLoading ? '2.25rem' : '1rem'
      }
    };
  },
  xs: props => {
    var {
      rightIcon,
      leftIcon,
      isLoading
    } = props;
    return {
      button: {
        minW: {
          md: '5.25rem'
        },
        pl: leftIcon ? '2rem' : '1rem',
        pr: rightIcon || isLoading ? '2rem' : '1rem'
      }
    };
  }
};
var buttonBase = () => {
  return {
    borderRadius: '3px',
    fontWeight: 'semibold',
    letterSpacing: 'tight',
    textAlign: 'center'
  };
};
export var primaryButtonStyles = props => {
  var {
    theme
  } = props;
  return {
    button: _objectSpread(_objectSpread({}, buttonBase()), {}, {
      color: 'white',
      bg: 'green.500',
      border: '2px solid transparent',
      _hover: {
        bg: 'green.850'
      },
      _focus: {
        bg: 'green.500',
        borderColor: 'white',
        boxShadow: "\n          0 0 0.125rem 0.125rem ".concat(getColor(theme, 'blue.200'), ", \n          0 0 0.125rem 0.125rem ").concat(getColor(theme, 'blue.300'))
      },
      _active: {
        bg: 'green.950'
      },
      _disabled: {
        bg: 'grey.800'
      }
    })
  };
};
export var secondaryButtonStyles = props => {
  var {
    theme
  } = props;
  var {
    focusBorderColor,
    focusBoxShadowColor,
    outlineFocusColor
  } = getDefaults(props);
  return {
    button: _objectSpread(_objectSpread({}, buttonBase()), {}, {
      color: 'blue.275',
      bg: 'white',
      borderColor: focusBorderColor,
      _hover: {
        bg: 'blue.1140'
      },
      _focus: {
        borderColor: focusBorderColor,
        outline: "2px solid ".concat(getColor(theme, outlineFocusColor)),
        boxShadow: "0 0 3px 2px ".concat(getColor(theme, focusBoxShadowColor))
      },
      _active: {
        bg: 'blue.250'
      },
      _disabled: {
        borderColor: 'grey.450'
      }
    })
  };
};
export var tertiaryButtonStyles = props => {
  var {
    theme
  } = props;
  return {
    button: _objectSpread(_objectSpread({}, buttonBase()), {}, {
      color: 'blue.275',
      bg: 'white',
      _hover: {
        bg: 'blue.1140'
      },
      _focus: {
        borderColor: 'blue.200',
        boxShadow: "0 0 3px 2px ".concat(getColor(theme, 'blue.300'))
      },
      _active: {
        bg: 'blue.250'
      }
    })
  };
};
export var dangerButtonStyles = props => {
  var {
    theme
  } = props;
  return {
    button: _objectSpread(_objectSpread({}, buttonBase()), {}, {
      color: 'white',
      bg: 'red.850',
      border: '2px solid transparent',
      _hover: {
        bg: 'red.1000'
      },
      _focus: {
        borderColor: 'white',
        boxShadow: "0 0 3px 2px ".concat(getColor(theme, 'red.1000'))
      },
      _active: {
        bg: 'red.400'
      },
      _disabled: {
        bg: 'grey.800',
        border: 'none'
      }
    })
  };
};
export var Button = asSingleStyleConfig({
  baseStyle: buttonBase,
  variants: {
    primary: primaryButtonStyles,
    secondary: secondaryButtonStyles,
    tertiary: tertiaryButtonStyles,
    danger: dangerButtonStyles
  },
  sizes
});